import React, { useEffect,useState } from "react";
import { useAuth } from "component/UseAuth";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import MasterCoADatatables from "component/akunting/master/master-coa/MasterCoATable";
import MasterCoAForm from "component/akunting/master/master-coa/MasterCoAForm";

function MasterChartAccount() {
  const { user } = useAuth();
  const [data, setData] = useState([
    {
      chart_account_code: "",
      chart_account_desc: "",
      group_account_code: "",
      group_account_desc: "",
      group_account_dep: "",
      group_account_div: "",
      group_account_table: "",
    },
  ]);
  const [modalMode, setModalMode] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const fetchMasterCoA = async (user) => {
    const token = localStorage.getItem("token");
    const reg_desc = user?.company;
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/show-master-coa`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ reg_desc })
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data Group Account");
  
      const data = await response.json();
      setData(data.data);
    } catch (error) {
      console.error("Error fetching Group Account:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Master Chart Account";
      window.scrollTo(0, 0);
      fetchMasterCoA(user);
  }, []);

  const handleAddMasterCoA = () => {
    setModalMode("add");
    setIsModalOpen(true);
  }
  
  const closeModal = () => {
    setIsModalOpen(false);
  }

  const handlePrint = () => {
    // window.print(); // atau arahkan ke halaman cetak khusus
  };
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Master Chart Account Management</h5>
                              <div className="d-flex gap-1">
                                <i className="bx bxs-plus-square" 
                                  style={{ color: "blue", fontSize: 30, cursor: "pointer" }} 
                                  onClick={handleAddMasterCoA}>
                                </i>
                                <i
                                  className="bx bxs-printer"
                                  title="Print"
                                  style={{ color: "blue", fontSize: 30, cursor: "pointer" }} 
                                  onClick={handlePrint}
                                ></i>
                              </div>
                            </div>
                            <MasterCoADatatables data={data} />
                          </div>
                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>
        {isModalOpen && (
          <div className="modal fade show" style={{ display: "block" }}>
            <MasterCoAForm mode={modalMode} user={user} closeModal={closeModal} onSuccess={fetchMasterCoA}/>
          </div>
        )}
    </div>
  );
}

export default MasterChartAccount;
